<template>
	<c-dialog ref="dialog" width="700" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<!-- 客户类型由业务场景带入时不展示该行，只在弹框标题上标注类型 -->
			<c-form-item v-if="!lockCustomerType" label="客户类型" required>
				<c-radio-group name="customer_type">
					<c-radio
						v-for="item in customerTypeOptions"
						:key="item.value"
						:value="item.value"
					>{{item.name}}</c-radio>
				</c-radio-group>
			</c-form-item>
			<c-form-item label="客户编号">
				<c-input name="customer_code" placeholder="请输入，忽略将自动生成"></c-input>
			</c-form-item>
			<c-form-item label="客户简称" required>
				<c-input name="customer_name"></c-input>
			</c-form-item>
			<c-form-item label="客户全称">
				<c-input name="customer_full_name"></c-input>
			</c-form-item>
			<c-form-item label="联系人">
				<c-input name="contact_name"></c-input>
			</c-form-item>
			<c-form-item label="联系电话">
				<c-input name="contact_phone"></c-input>
			</c-form-item>
			<c-form-item label="联系地址">
				<c-input name="contact_address"></c-input>
			</c-form-item>
			<c-form-item label="授信额度" tip="客户开通授信，则线下订单允许使用授信付款">
                <c-input type="number" name="credit_balance"  :decimal="2" :range="[0,9999999]"
                         placeholder="请输客户授信额度"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleCustomerEdit',

		props: {
			//外部指定的客户类型（1：同行客户，2：零售客户），指定后不展示类型选择控件，类型在弹框标题标注并固定提交
			customer_type: [String, Number],
			//外部预置的客户类型（1：同行客户，2：零售客户）：仅新建时自动勾选该类型，仍可手动改选，不锁定
			default_customer_type: [String, Number]
		},

		data() {
			return {
				customerTypeOptions: [
					{name: '零售客户', value: 2},
					{name: '同行客户', value: 1},
				]
			}
		},

		computed: {
			//是否锁定客户类型（外部指定客户类型时不展示可选控件）
			lockCustomerType() {
				return !!this.customer_type;
			},
			//锁定时用于弹框标题标注的类型名称
			lockCustomerTypeName() {
				var item = this.customerTypeOptions.find(item => item.value == Number(this.customer_type));
				return item ? item.name : '';
			}
		},

		methods: {
			/*********打开编辑框，初始化**********/
			open(data) {
				this._editState = !!data;
				this.$refs.form.clear();
				if (data) {
					this.$refs.form.set(data);
					//查询客户详情
					this.request({
						url: '/sale/customer/detail',
						data: {id: data.id},
						success: data => {
							// 确保 customer_type 为数字类型，与 options 的 value 匹配
							if (data.customer_type) {
								data.customer_type = parseInt(data.customer_type);
							}
							this.$refs.form.set(data);
						}
					});
				} else if (!this.lockCustomerType) {
					//可自由选择时按外部预置类型自动勾选（如列表当前视图对应类型），未预置或预置非法则默认零售客户；类型锁定时不渲染类型控件，无需回填
					this.$refs.form.set({customer_type: this.resolveDefaultCustomerType()});
				}
				this.$refs.dialog.open({
					title: this.getDialogTitle(data)
				});
			},

			/*********新建时的默认勾选类型：优先外部预置（须为合法选项），否则零售客户**********/
			resolveDefaultCustomerType() {
				var preset = this.default_customer_type == null || this.default_customer_type === '' ? null : parseInt(this.default_customer_type);
				var hit = this.customerTypeOptions.find(item => item.value === preset);
				return hit ? hit.value : 2;
			},

			/*********弹框标题：业务场景指定了客户类型时在标题上标注**********/
			getDialogTitle(data) {
				if (data) return '编辑客户';
				return this.lockCustomerType ? '新建客户（' + this.lockCustomerTypeName + '）' : '新建客户';
			},

			/*******创建、编辑提交处理方法********/
			editHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: this._editState ? '/sale/customer/update' : '/sale/customer/add',
					rule: {
						customer_type: {
							check: [{type: 'empty', message: '请选择客户类型'}],
							//类型锁定时表单中无该控件，取不到值，跳过校验并由dataFormatter补齐
							skip: () => this.lockCustomerType
						},
						customer_name: '请输入客户简称'
					},
					dataFormatter: data => {
						//外部指定了客户类型时，强制按指定类型提交
						if (this.customer_type) {
							data.customer_type = Number(this.customer_type);
						}
                        data.credit_balance = data.credit_balance||0;
                        return data;
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
